var map = {
	"./PM10.png": "0c00",
	"./PM2.5.png": "17f9",
	"./TVOC.png": "a060",
	"./airconditioning.png": "8faa",
	"./co2.png": "5750",
	"./co2_b.png": "820c",
	"./cold.png": "4634",
	"./curtain.png": "e54d",
	"./fan.png": "1c04",
	"./formaldehyde.png": "3aad",
	"./formaldehyde_b.png": "21bc",
	"./freshair.png": "fa4c",
	"./freshair_b.png": "dd63",
	"./heat.png": "30a6",
	"./humantouch.png": "e9d3",
	"./humantouch1.png": "ee1f",
	"./humidifier1.png": "792d",
	"./humidity.png": "18be",
	"./humidity1.png": "8ff2",
	"./light-sensitive.png": "ee73",
	"./light.png": "6a63",
	"./lightsensitive.png": "989c",
	"./pm10_b.png": "adc7",
	"./pm2.5_b.png": "75ef",
	"./scenes.png": "cea3",
	"./temperature.png": "43cd",
	"./tvoc_b.png": "860c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7315";